var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-inline-flex align-center"},[_c('c-state-count-changes-chip',{attrs:{"state":_vm.state}},[_vm._v(_vm._s(_vm.affect.from))]),_c('v-icon',{attrs:{"size":"16"}},[_vm._v("arrow_forward")]),_c('c-state-count-changes-chip',{attrs:{"state":_vm.state}},[_vm._v(_vm._s(_vm.affect.to))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }